export default "__VITE_ASSET__C$akrqGa__"